import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import Peaks from 'peaks.js';
import { DataPassService } from '../../providers/Global/dataPass.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonFunctionsService } from '../../providers/Global/commonFunctions.service';
import { Globals } from '../../ressources/variables/globals';

@Component({
  selector: 'app-waveform',
  templateUrl: './waveform.component.html',
  styleUrls: ['./waveform.component.scss']
})
export class WaveformComponent implements OnInit, AfterViewInit {

  @ViewChild('audioEl') audioEl: ElementRef;
  @ViewChild('waveformZoomContainer') waveformZoomContainer: ElementRef;
  @ViewChild('waveformOverviewContainer') waveformOverviewContainer: ElementRef;

  peakInstance;

  position = 0;

  options;

  regionStart = null;
  regionMix = null;
  pointIntro = null;
  fade = '3';

  serverEndpoint = Globals.serverEndpoint;

  constructor(private bottomSheetRef: MatBottomSheetRef<any>,
              @Inject(MAT_BOTTOM_SHEET_DATA) private dataIn: any,
              public dataPassService: DataPassService,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              private changeDetectorRef: ChangeDetectorRef,
              public CF: CommonFunctionsService) {
    iconRegistry.addSvgIcon('play', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play.svg'));
    iconRegistry.addSvgIcon('add', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/add.svg'));
    iconRegistry.addSvgIcon('remove', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/remove.svg'));
  }

  ngOnInit() {
    this.position = this.dataIn.position;
    this.dataPassService.selectedWaveformSource.next(this.position);
  }

  ngAfterViewInit() {
    this.options = {
      zoomview: {
        container: this.waveformZoomContainer.nativeElement,
        waveformColor: '#A9A9A9'
      },
      overview: {
        container: this.waveformOverviewContainer.nativeElement
      },
      mediaElement: this.audioEl.nativeElement,
      dataUri: {
        arraybuffer: this.serverEndpoint + '/api/getWaveform'
                    + '?filename=' + this.CF.escapeSpecialsURL(this.replacePlusSymbol(this.dataPassService.musiques_mix[this.position].file))
                    + '&folder=' + this.dataPassService.musiques_mix[this.position].folder
      },
      keyboard: true,
      pointMarkerColor: '#39B54A'
    };

    this.peakInstance = Peaks.init(this.options, (err, peaks) => {
      if (err) {
        console.log(err);
      } else {
        console.log(peaks);
      }
    });

    if (this.dataPassService.musiques_mix[this.position].mix.fade) {
      this.fade = this.dataPassService.musiques_mix[this.position].mix.fade;
    }

    this.peakInstance.on('peaks.ready', () => {
      this.peakInstance.segments.removeAll();
      this.peakInstance.points.removeAll();

      if (typeof this.dataPassService.musiques_mix[this.position].mix.start === 'number'
        && typeof this.dataPassService.musiques_mix[this.position].mix.mix === 'number') {
        this.regionStart = this.dataPassService.musiques_mix[this.position].mix.start;
        this.regionMix = this.dataPassService.musiques_mix[this.position].mix.mix;
      } else {
        this.regionStart = 0;
        this.regionMix = 0;
      }

      if (typeof this.dataPassService.musiques_mix[this.position].mix.intro === 'number') {
        this.pointIntro = this.dataPassService.musiques_mix[this.position].mix.intro;

        const point = {
          time: this.pointIntro,
          color: '#39B54A',
          editable: true
        };
        this.peakInstance.points.add([point]);
      } else {
        this.pointIntro = 0;
      }

      this.majSegments();
    });

    this.peakInstance.on('segments.dragend', (event) => {
      switch (event.segment._labelText) {
        case 'Selection':
          this.regionStart = event.segment._startTime;
          this.regionMix = event.segment._endTime;
          this.dataPassService.musiques_mix[this.position].mix.start = this.regionStart;
          this.dataPassService.musiques_mix[this.position].mix.mix = this.regionMix;
          this.majSegments();
          break;
        default:
          break;
      }
      this.changeDetectorRef.detectChanges();
    });

    this.peakInstance.on('points.dragend', (event) => {
      this.pointIntro = event.point._time;
      this.dataPassService.musiques_mix[this.position].mix.intro = this.pointIntro;
      this.majSegments();
      this.changeDetectorRef.detectChanges();
    });
  }

  setValueSegment(element) {
    const currentCursor = this.peakInstance.player.getCurrentTime();
    switch (element) {
      case 'start':
        this.regionStart = currentCursor;
        if (this.regionMix < this.regionStart) {
          this.regionMix = this.regionStart + 1;
        }
        this.dataPassService.musiques_mix[this.position].mix.start = this.regionStart;
        this.dataPassService.musiques_mix[this.position].mix.mix = this.regionMix;
        break;
      case 'mix':
        this.regionMix = currentCursor;
        if (this.regionMix < this.regionStart) {
          this.regionStart = this.regionMix - 1;
        }
        this.dataPassService.musiques_mix[this.position].mix.start = this.regionStart;
        this.dataPassService.musiques_mix[this.position].mix.mix = this.regionMix;
        break;
      default:
        break;
    }
    this.majSegments();
  }

  incrementValueSegment(element, sens) {
    switch (element) {
      case 'start':
        if (typeof this.regionStart === 'number') {
          let regionStart;
          if (sens === '-') {
            regionStart = (this.regionStart - 0.05);
          } else if (sens === '+') {
            regionStart = (this.regionStart + 0.05);
          }
          if (regionStart <= 0) {
            this.regionStart = 0;
          } else {
            this.regionStart = regionStart;
          }
          if (this.regionMix < this.regionStart) {
            this.regionMix = this.regionStart + 1;
          }
          this.dataPassService.musiques_mix[this.position].mix.start = this.regionStart;
          this.dataPassService.musiques_mix[this.position].mix.mix = this.regionMix;
          this.audioEl.nativeElement.currentTime = this.regionStart;
          this.audioEl.nativeElement.play();
        }
        break;
      case 'mix':
        if (typeof this.regionMix === 'number') {
          if (sens === '-') {
            this.regionMix = (this.regionMix - 0.05);
          } else if (sens === '+') {
            this.regionMix = (this.regionMix + 0.05);
          }
          if (this.regionMix <= 0.5) {
            this.regionMix = 0.6;
          }
          if (this.regionMix < this.regionStart) {
            this.regionStart = this.regionMix - 1;
          }
          this.dataPassService.musiques_mix[this.position].mix.start = this.regionStart;
          this.dataPassService.musiques_mix[this.position].mix.mix = this.regionMix;
          this.audioEl.nativeElement.currentTime = this.regionMix;
          this.audioEl.nativeElement.play();
        }
        break;
      default:
        break;
    }
    this.majSegments();
  }

  setValueIntro() {
    const currentCursor = this.peakInstance.player.getCurrentTime();
    this.pointIntro = currentCursor;
    this.dataPassService.musiques_mix[this.position].mix.intro = this.pointIntro;
    this.peakInstance.points.removeAll();
    const point = {
      time: this.pointIntro,
      color: '#39B54A',
      editable: true
    };
    this.peakInstance.points.add([point]);
    this.majSegments();
  }

  incrementValueIntro(sens) {
    if (typeof this.pointIntro === 'number') {
      if (sens === '-') {
        this.pointIntro = (this.pointIntro - 0.05);
      } else if (sens === '+') {
        this.pointIntro = (this.pointIntro + 0.05);
      }
      if (this.pointIntro <= 0 || this.pointIntro >= this.dataPassService.musiques_mix[this.position].mix.duration) {
        this.pointIntro = 0;
      }
      this.dataPassService.musiques_mix[this.position].mix.intro = this.pointIntro;
      this.audioEl.nativeElement.currentTime = this.pointIntro;
      this.audioEl.nativeElement.play();
      this.peakInstance.points.removeAll();
      if (this.pointIntro > 0) {
        const point = {
          time: this.pointIntro,
          color: '#39B54A',
          editable: true
        };
        this.peakInstance.points.add([point]);
      }
      this.majSegments();
    }
  }

  previewValue(element) {
    switch (element) {
      case 'start':
        if (typeof this.regionStart === 'number') {
          this.audioEl.nativeElement.currentTime = this.regionStart;
          this.audioEl.nativeElement.play();
        }
        break;
      case 'mix':
        if (typeof this.regionMix === 'number') {
          this.audioEl.nativeElement.currentTime = this.regionMix;
          this.audioEl.nativeElement.play();
        }
        break;
      case 'intro':
        if (typeof this.pointIntro === 'number') {
          this.audioEl.nativeElement.currentTime = this.pointIntro;
          this.audioEl.nativeElement.play();
        }
        break;
      default:
        break;
    }
  }

  majSegments() {
    this.peakInstance.segments.removeAll();
    if (typeof this.dataPassService.musiques_mix[this.position].mix.start === 'number'
      && typeof this.dataPassService.musiques_mix[this.position].mix.mix === 'number'
      && typeof this.regionStart === 'number'
      && typeof this.regionMix === 'number') {
      const segment = {
        startTime: this.regionStart,
        endTime: this.regionMix,
        editable: true,
        color: 'rgba(255, 214, 0, 0.8)',
        labelText: 'Selection'
      };
      this.peakInstance.segments.add([segment]);
    }
    if (typeof this.regionStart === 'number'
      && typeof this.pointIntro === 'number'
      && this.pointIntro > this.regionStart) {
      const introZone = {
        startTime: this.regionStart,
        endTime: this.pointIntro,
        editable: false,
        color: 'rgba(57, 181, 74, 0.6)',
        labelText: 'IntroZone'
      };
      this.peakInstance.segments.add([introZone]);
    }
  }

  onValFadeChange(val: string) {
    this.fade = val;
    this.dataPassService.musiques_mix[this.position].mix.fade = this.fade;
  }

  openLink(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  changeFile(dir) {
    this.bottomSheetRef.dismiss({change: true, direction: dir});
  }

  replacePlusSymbol(str) {
    return str.replace(/\+/gi, '%2B');
  }

}
